import React from 'react';
import { Text } from '@mentimeter/ragnar-ui/text';
import { Box } from '@mentimeter/ragnar-ui/box';
import {
  PopoverAnchor,
  PopoverBody,
  PopoverContainer,
  PopoverHeader,
  PopoverRoot,
} from '@mentimeter/ragnar-ui/popover';
import { ScreenReaderOnly } from '@mentimeter/ragnar-ui/screenreader-only';
import { Dark, Light } from '@mentimeter/ragnar-ui/themes';
import { PulsatingPurpleDot } from './PulsatingPurpleDot';

interface ChecklistTooltipProps {
  show: boolean;
  text: string;
  direction: 'bottom' | 'top' | 'left' | 'right';
  checklistRef: React.RefObject<HTMLElement>;
}

const DOT_LEFT_TRANSFORM = 'translate(calc(100% + 14px), calc(50% - 6px))';
const DOT_BOTTOM_TRANSFORM = 'translate(calc(67% - 1px), calc(-50% + 4px))';
const DOT_TOP_TRANSFORM = 'translate(calc(50% - 6px), calc(100% + 12px))';
const DOT_RIGHT_TRANFORM = 'translate(calc(0% - 26px), calc(50% - 6px))';

const getDotTransform = (
  direction: 'bottom' | 'top' | 'left' | 'right',
): string => {
  switch (direction) {
    case 'bottom':
      return DOT_BOTTOM_TRANSFORM;
    case 'left':
      return DOT_LEFT_TRANSFORM;
    case 'top':
      return DOT_TOP_TRANSFORM;
    case 'right':
      return DOT_RIGHT_TRANFORM;
    default:
      return DOT_BOTTOM_TRANSFORM;
  }
};

export const ChecklistTooltip = ({
  show,
  text,
  direction,
  checklistRef,
}: ChecklistTooltipProps) => {
  return (
    <Box alignItems="center">
      <PopoverRoot open={show}>
        <PopoverAnchor virtualRef={checklistRef} />
        <Dark>
          <PopoverContainer
            sideOffset={30}
            side={direction}
            m="auto"
            className="dark"
          >
            <Light>
              <Box
                width="100%"
                height="100%"
                position="absolute"
                extend={() => ({
                  transform: getDotTransform(direction),
                })}
              >
                <PulsatingPurpleDot size={12} />
              </Box>
            </Light>
            <PopoverHeader showDismiss={false}>
              <ScreenReaderOnly>{text}</ScreenReaderOnly>
            </PopoverHeader>
            <PopoverBody>
              <Text color="text">{text}</Text>
            </PopoverBody>
          </PopoverContainer>
        </Dark>
      </PopoverRoot>
    </Box>
  );
};
